import { Injectable } from '@rxdi/core';

/**
 * Smooth-scrolls to a home-page section by its element name (e.g. `rs-contact`).
 * The home page registers its shadow root; sections are looked up when asked,
 * because they render after the content arrives.
 */
@Injectable()
export class ScrollToService {
  #root: ParentNode | null = null;

  setRoot(root: ParentNode): void {
    this.#root = root;
  }

  scrollToElement(elementName: string): void {
    this.#root?.querySelector(elementName)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
}
